import { useDynamicLocale } from '@/hoslog-intl';
import { LayerGroupIcon, StoreInformation } from '@/icons';
import { GroupSummaryData } from '@/services/groupsManagement/groupsManagement.types';
import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';

const getDashboardStats = (data: GroupSummaryData) => [
  {
    id: 'configurationManagement.groupsManagement.cards.totalGroups',
    label: 'Total Groups',
    value: data.totalGroup,
    unit: '件',
    icon: LayerGroupIcon,
  },
  {
    id: 'configurationManagement.groupsManagement.cards.totalStores',
    label: 'Total Stores',
    value: data.totalStore,
    unit: '件',
    icon: StoreInformation,
  },
  {
    id: 'configurationManagement.groupsManagement.cards.totalAssignedStores',
    label: 'Total Assigned Stores',
    value: data.totalAssignedStore,
    unit: '件',
    icon: StoreInformation,
  },
  {
    id: 'configurationManagement.groupsManagement.cards.totalUnAssignedStores',
    label: 'Total UnAssigned Stores',
    value: data.totalUnAssignedStore,
    unit: '件',
    icon: StoreInformation,
  },
];

const formatLabel = (label: string) => {
  const [first, ...rest] = label.split(' ');
  return (
    <>
      {first}
      {rest.length > 0 && <span className="block">{rest.join(' ')}</span>}
    </>
  );
};

const GroupSummary = ({ data }: { data: GroupSummaryData }) => {
  const dashboardStats = getDashboardStats(data);
  const { t } = useDynamicLocale();

  return (
    <>
      <h2 className="text-base font-bold mb-4">{t('configurationManagement.groupsManagement.cards.title')}</h2>

      <div className="grid grid-cols-4 gap-4 mb-8">
        {dashboardStats.map((stat, index) => {
          const Icon = stat.icon;

          return (
            <div
              key={stat.id}
              className="py-3 pl-4 pr-11 relative min-h-[100px] flex flex-col gap-3 justify-between bg-card rounded shadow border border-foreground-strong"
            >
              <div className="absolute right-0 top-0 bg-surface-inverse px-[3.97px] py-1 rounded-bl-sm">
                <Icon className="text-foreground-inverse size-5" />
              </div>
              <div className="flex justify-between items-start">
                <div className="text-sm font-bold text-foreground-strong">{formatLabel(t(stat.id))}</div>

                {index !== 0 && (
                  <div className="flex items-center gap-0.5">
                    <Link
                      to={'/configuration-management/group-management'}
                      className="text-foreground-strong text-caption font-medium hover:underline whitespace-nowrap"
                    >
                      詳細
                    </Link>
                    <ChevronRight className="size-4 mt-0.5" />
                  </div>
                )}
              </div>

              <div className="font-display flex items-center gap-1">
                <span className="text-stat">{stat.value}</span>
                <span className="text-[20px] inline-block mt-2">{stat.unit}</span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default GroupSummary;
